// actions
import { Commit, ActionTree, Dispatch } from 'vuex';
import axios, { AxiosPromise, AxiosResponse } from 'axios';
import graphQl, { grahqlQueryServiceV2 } from '@/services/graphQl';
import * as types from '../../apm/mutation-types';
import { cancelToken } from '@/utils/cancelToken';
// import { State } from './dashboard-data';
import fragmentAll from './dashboard.metrcis.types';
import apmDashboard from '@/utils/templates/apm.dashboard.charts.template';
import homeDashboard from '@/utils/templates/home.template.charts';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import rootStateStore, { State } from '../apmCommonState/apmCommonState.store';
import { AuthService } from '@/services/api/auth.service';
import shortenLargeNumber from '@/utils/numberShortner';
import dotnetInstanceGraphsConfig from '@/utils/templates/apmTemplates/dotnet.instance.graphs.config';
import { dotNetLang } from '@/components/APM/Dashboard/Instance/instance.constants';

const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';
let arry = [] as any;
let currentLanguage = 'JAVA';
export enum TopologyType {
  TOPOLOGY_ENDPOINT = 'TOPOLOGY_ENDPOINT',
  TOPOLOGY_INSTANCE = 'TOPOLOGY_INSTANCE',
}

const actions: ActionTree<State, any> = {
  GET_ALL_SAMPLE_RECORDS(
    context: { commit: Commit },
    params: any,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryAllSampleRecords')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit(
                'setDatabaseQuery',
                res.data.data.readAllSampledRecords.records,
              );
              context.commit(
                'setDatabaseQueryTotal',
                res.data.data.readAllSampledRecords.total,
              );
              resolve();
            }
          })
          .catch((err) => {
            console.log('error', err);
          });
      }
    });
  },
  GET_META_DATA(context: { commit: Commit }, params: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryMetaData')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              let records = res.data.data.response.records;
              records.forEach((record: any) => {
                let _record: {} = record;
                Object.entries(record).forEach(([key, value]) => {
                  if (typeof value === 'number') {
                    _record[key] = shortenLargeNumber(value, 2);
                  }
                });
              });
              context.commit('setMetaData', [
                res.data.data.response.records,
                res.data.data.response.total,
                params.condition.filterCondition.scope,
              ]);
              resolve();
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  SET_INSTANCE_CUSTOM_META(
    context: { commit: Commit },
    params: {
      serviceId: number;
      entityId: any;
      operation: string;
      name: string;
    },
  ): Promise<any> {
    {
      return new Promise((resolve, reject) => {
        if (params.entityId && params.serviceId && params.operation) {
          const globalArr: any = fragmentAll;
          const fragments = globalArr.instanceNameMutation.mutation;
          const queryVariables = globalArr.instanceNameMutation.variable;
          const query = `mutation instanceNameMutation(${queryVariables}) {${fragments}}`;
          return new axiosInstance({ auth: true })
            .post(
              OAP_HOST + '/graphql',
              { query, variables: { request: params } },
              {},
            )
            .then((res: AxiosResponse<any>) => {
              resolve(res);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        }
      });
    }
  },
  getQuery(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      isSlow: { type: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      isTraceGraph: boolean;
      dependency: string;
      compareDuration: any;
      sortOrder: string;
    },
  ) {
    const {
      currentDatabaseService,
      currentEndpoint,
      currentInstance,
      currentService,
    } = context.rootState.apmState.apmCommonState;
    //noraml is true for apm service,endpoint and instance
    // normal will be false for database
    // TODO
    // Changing the var from normal to something meaningful requires backend changes so it will TODO
    const normal = params.dashboardType.isDatabase ? false : true;
    let config = {} as any;
    const names = ['readSampledRecords', 'sortMetrics'];

    if (params.type === TopologyType.TOPOLOGY_ENDPOINT) {
      const endpointComps: string = `${window.localStorage.getItem(
        'topologyEndpoints',
      )}`;
      const topoEndpoint = endpointComps ? JSON.parse(endpointComps) : [];
      config = topoEndpoint[params.index];
    } else if (params.type === TopologyType.TOPOLOGY_INSTANCE) {
      const instanceComps: string = `${window.localStorage.getItem(
        'topologyInstances',
      )}`;
      const topoInstance = instanceComps ? JSON.parse(instanceComps) : [];
      config = topoInstance[params.index];
    } else {
      // Check the entity type and set the configs accordingly
      switch (context.rootState.apmState.dashboard.currentTab) {
        case 'Service':
          if (params.isTraceGraph) {
            config =
              context.rootState.globalState.app.chartsTemplate.trace[
                params.layoutIndex
              ][params.index];
            break;
          } else if (params.children.present) {
            config =
              context.rootState.globalState.app.chartsTemplate.service[
                params.layoutIndex
              ][params.index].childQueries[params.children.childIndex];
            break;
          } else {
            config =
              context.rootState.globalState.app.chartsTemplate.service[
                params.layoutIndex
              ][params.index];
            break;
          }

        case 'Endpoint':
          if (params.children.present) {
            config =
              context.rootState.globalState.app.chartsTemplate.endpoint[
                params.layoutIndex
              ][params.index].childQueries[params.children.childIndex];
            break;
          } else {
            config =
              context.rootState.globalState.app.chartsTemplate.endpoint[
                params.layoutIndex
              ][params.index];
            break;
          }
        case 'Instance':
          if (
            context.rootState.apmState.apmCommonState.currentServiceLanguage ===
              dotNetLang &&
            params.dependency
          ) {
            config =
              dotnetInstanceGraphsConfig()[params.dependency]['lineCharts'][
                params.index
              ];
            break;
          }
          if (
            arry.length === 0 ||
            context.rootState.apmState.apmCommonState.currentServiceLanguage !==
              currentLanguage
          ) {
            arry = [];
            currentLanguage =
              context.rootState.apmState.apmCommonState.currentServiceLanguage;
            for (const [
              index,
              el,
            ] of context.rootState.globalState.app.chartsTemplate.instance[
              params.layoutIndex
            ].entries()) {
              if (el.isCommon) {
                arry.push(el);
                continue; // Skipping as its added in this current segment/block.
              }
              // Checking and adding language based entries
              if (
                context.rootState.apmState.apmCommonState
                  .currentServiceLanguage === el.language
              ) {
                //el.language
                arry.push(el);
              }
            }
          }
          if (params.children.present) {
            config =
              arry[params.index].childQueries[params.children.childIndex];
            break;
          } else {
            config = arry[params.index];
            break;
          }

        case 'AppDB':
          if (params.children.present) {
            config =
              context.rootState.globalState.app.chartsTemplate.appdb[
                params.layoutIndex
              ][params.index].childQueries[params.children.childIndex];
            break;
          } else {
            config =
              context.rootState.globalState.app.chartsTemplate.appdb[
                params.layoutIndex
              ][params.index];
            break;
          }
        default:
          config =
            context.rootState.globalState.app.chartsTemplate.service[
              params.index
            ];
          break;
      }
      // if (!normal) {

      //   if (params.children.present) {
      //     config =
      //       context.rootState.globalState.app.chartsTemplate.appdb[
      //         params.layoutIndex
      //       ][params.index].childQueries[params.children.childIndex];
      //   } else {
      //     config =
      //       context.rootState.globalState.app.chartsTemplate.appdb[
      //         params.layoutIndex
      //       ][params.index];
      //   }
      // }
    }
    if (!config) {
      return;
    }
    if (!config.metricName) {
      return;
    }
    // remove the space at the beginning and end of the string
    const metricNames = config.metricName
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const labelsIndex = (config.labelsIndex || '')
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const currentServiceId = config.independentSelector
      ? config.currentService
      : currentService.key;
    const currentInstanceId = config.independentSelector
      ? config.currentInstance
      : currentInstance.key;
    const currentEndpointId = config.independentSelector
      ? config.currentEndpoint
      : currentEndpoint.key;
    const currentDatabaseId = config.independentSelector
      ? config.currentDatabase
      : currentDatabaseService.key;
    const labels =
      config.metricType === 'LABELED_VALUE' ? labelsIndex : undefined;
    const variablesList = metricNames.map((name: string) => {
      let variables = {} as any;
      // This is for globhal dashboard
      if (config.entityType === 'All') {
        variables = names.includes(config.queryMetricType)
          ? {
              duration: params.duration,
              condition: {
                name,
                parentService: null,
                normal: true,
                scope: config.entityType,
                topN: 10,
                order: config.sortOrder || 'DES',
              },
            }
          : {
              duration: params.duration,
              condition: {
                name,
                entity: {
                  scope: config.entityType,
                  normal: true,
                },
              },
              labels,
            };
      } else {
        if (names.includes(config.queryMetricType)) {
          // this is probably for slow traces
          const parentService = normal ? currentServiceId : currentDatabaseId;
          if (config.parentService && !parentService) {
            return;
          }
          variables = {
            duration: params.duration,
            condition: {
              name, 
              parentService: config.parentService ? currentService.key : null,
              normal,
              scope: normal
                ? config.entityType
                : config.parentService
                  ? 'Service'
                  : config.entityType,
              topN: 10,
              order: params.sortOrder || 'DES',
            },
          };
        } else {
          const traceInstanceName =
            context.rootState.apmState.trace?.traceSpans?.correlatedInstanceId;
          const serviceName = params.isTraceGraph
            ? traceInstanceName.substring(0, traceInstanceName.indexOf('_'))
            : normal
              ? currentServiceId
              : currentDatabaseId;
          if (!serviceName) {
            return null;
          }
          if (config.entityType === 'ServiceInstance' && !currentInstanceId) {
            return null;
          }
          if (config.entityType === 'Endpoint' && !currentEndpointId) {
            return null;
          }
          variables = {
            condition: {
              name,
              entity: {
                scope: normal ? config.entityType : 'Service',
                serviceName,
                serviceInstanceName: params.isTraceGraph
                  ? traceInstanceName
                  : config.entityType === 'ServiceInstance'
                    ? currentInstanceId
                    : undefined,
                endpointName:
                  config.entityType === 'Endpoint'
                    ? currentEndpointId
                    : undefined,
                normal,
                // destNormal: normal,
                // destServiceName: '',
                // destServiceInstanceName: '',
                // destEndpointName: '',
              },
            },
            labels,
          };
          if (context.rootState.globalState.settings.isCompareOptionsSelected && (config.queryMetricType === "readMetricsValues" || config.queryMetricType === "readLabeledMetricsValues" || (config.queryMetricType === "readMetricsValue" && config.metricName !== 'service_apdex'))) {
            variables.durationCurrent = params.duration;
            variables.durationCompared = params.compareDuration;
          } else {
            variables.duration = params.duration;
          }
        }
      }
      return variables;
    });

    const globalArr: any = fragmentAll;
    if (!config.queryMetricType || !variablesList.length) {
      return;
    }
    const  isCompareOptionsSelected  = context.rootState.globalState.settings.isCompareOptionsSelected;
    const metricTypeKey = (isCompareOptionsSelected  && (config.queryMetricType === "readMetricsValues" || config.queryMetricType === "readLabeledMetricsValues" || (config.queryMetricType === "readMetricsValue" && config.metricName !== 'service_apdex')))
                          ? `${config.queryMetricType}Compare` : config.queryMetricType;
    const fragments = globalArr[metricTypeKey].fragment;
    const queryVariables = globalArr[metricTypeKey].variable;
    const query = `query queryData(${queryVariables}) {${fragments}}`;
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          return new axiosInstance({ auth: true })
            .post(
              OAP_HOST + '/graphql',
              { query, variables: variable },
              {
                // cancelToken: cancelToken()
              },
            )
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              if (variable.condition.name === 'service_total_call') {
                if (resData.readMetricsValues.total > 0) {
                  context.commit('setApdexEnabled', true);
                } else {
                  context.commit('setApdexEnabled', false);
                }
              }
              return {
                ...resData,
                config,
                metricName: variable.condition.name,
              };
            })
            .catch((error) => error);
        } else {
          return { config };
        }
      }),
    ).then((data: any) => {
      return data;
    });
  },
  //TODO remove the QueryHome once home page is ready
  getQueryHome(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
    },
  ) {
    const {
      currentDatabaseService,
      currentEndpoint,
      currentInstance,
      currentService,
    } = context.rootState.apmState.apmCommonState;
    //noraml is true for apm service,endpoint and instance
    // normal will be false for database
    // TODO
    // Changing the var from normal to something meaningful requires backend changes so it will TODO
    const normal = params.dashboardType.isDatabase ? false : true;

    let config = {} as any;
    const names = ['readSampledRecords', 'sortMetrics'];

    if (params.type === TopologyType.TOPOLOGY_ENDPOINT) {
      const endpointComps: string = `${window.localStorage.getItem(
        'topologyEndpoints',
      )}`;
      const topoEndpoint = endpointComps ? JSON.parse(endpointComps) : [];
      config = topoEndpoint[params.index];
    } else if (params.type === TopologyType.TOPOLOGY_INSTANCE) {
      const instanceComps: string = `${window.localStorage.getItem(
        'topologyInstances',
      )}`;
      const topoInstance = instanceComps ? JSON.parse(instanceComps) : [];
      config = topoInstance[params.index];
    } else {
      // Check the entity type and set the configs accordingly

      config = homeDashboard.home[params.index];

      if (!normal) {
        config = apmDashboard.appdb[params.index];
      }
    }
    if (!config) {
      return;
    }
    if (!config.metricName) {
      return;
    }
    // remove the space at the beginning and end of the string
    const metricNames = config.metricName
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const labelsIndex = (config.labelsIndex || '')
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const currentServiceId = config.independentSelector
      ? config.currentService
      : currentService.key;
    const currentInstanceId = config.independentSelector
      ? config.currentInstance
      : currentInstance.key;
    const currentEndpointId = config.independentSelector
      ? config.currentEndpoint
      : currentEndpoint.key;
    const currentDatabaseId = config.independentSelector
      ? config.currentDatabase
      : currentDatabaseService.key;
    const labels =
      config.metricType === 'LABELED_VALUE' ? labelsIndex : undefined;
    const variablesList = metricNames.map((name: string) => {
      let variables = {} as any;
      // This is for globhal dashboard
      if (config.entityType === 'All') {
        variables = names.includes(config.queryMetricType)
          ? {
              duration: params.duration,
              condition: {
                name,
                parentService: null,
                normal: true,
                scope: config.entityType,
                topN: 10,
                order: config.sortOrder || 'DES',
              },
            }
          : {
              duration: params.duration,
              condition: {
                name,
                entity: {
                  scope: config.entityType,
                  normal: true,
                },
              },
              labels,
            };
      } else {
        if (names.includes(config.queryMetricType)) {
          // this is probably for slow traces
          const parentService = normal ? currentServiceId : currentDatabaseId;
          if (config.parentService && !parentService) {
            return;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              parentService: config.parentService ? currentService.key : null,
              normal,
              scope: normal
                ? config.entityType
                : config.parentService
                  ? 'Service'
                  : config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES',
            },
          };
        } else {
          const serviceName = normal ? currentServiceId : currentDatabaseId;
          if (!serviceName) {
            return null;
          }
          if (config.entityType === 'ServiceInstance' && !currentInstanceId) {
            return null;
          }
          if (config.entityType === 'Endpoint' && !currentEndpointId) {
            return null;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              entity: {
                scope: normal ? config.entityType : 'Service',
                serviceName,
                serviceInstanceName:
                  config.entityType === 'ServiceInstance'
                    ? currentInstanceId
                    : undefined,
                endpointName:
                  config.entityType === 'Endpoint'
                    ? currentEndpointId
                    : undefined,
                normal,
                // destNormal: normal,
                // destServiceName: '',
                // destServiceInstanceName: '',
                // destEndpointName: '',
              },
            },
            labels,
          };
        }
      }
      return variables;
    });

    const globalArr: any = fragmentAll;
    if (!config.queryMetricType || !variablesList.length) {
      return;
    }
    const fragments = globalArr[config.queryMetricType].fragment;
    const queryVariables = globalArr[config.queryMetricType].variable;
    const query = `query queryData(${queryVariables}) {${fragments}}`;
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
          return new axiosInstance({ auth: true })
            .post(
              OAP_HOST + '/graphql',
              { query, variables: variable },
              {
                // cancelToken: cancelToken()
              },
            )
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              return {
                ...resData,
                config,
                metricName: variable.condition.name,
              };
            })
            .catch((error) => error);
        } else {
          return { config };
        }
      }),
    ).then((data: any) => {
      return data;
    });
  },
  GET_ALL_QUERY_RECORDS({ commit }: { commit: Commit }, params: any): Promise<any> {
    if (!params) return Promise.reject(new Error('Invalid parameters'));
  
    return graphQl
      .query('queryDownloadAllSampleRecords')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data?.data) throw new Error('No data received');
        return res.data.data.downloadAllSampleRecords.records;
      })
      .catch((err) => {
        console.error('Error:', err);
        throw err;
      });
  },
  getActiveInstance(context: { commit: Commit }, params: any): Promise<void> {
    return graphQl
      .query('queryGetActiveInstancesCount')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data.data) {
          throw Error(res.data);
        } else {
          context.commit(
            'setActiveInstanceCount',
            res.data.data.getActiveInstancesCount.activeInstancesCount,
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_PROFILES(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
    },
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryGetProfiles')
          .params({ request: params })
          .then((res: AxiosResponse<any>) => {
            if (!res?.data?.data?.response) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              resolve(res.data.data.response);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },

  getSocketData(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        grahqlQueryServiceV2
          .query('querySocketIO')
          .params({
            request: {
              ...params,
              metricType: 'GC_CONFIG',
            },
          })
          .then((res: AxiosResponse<any>) => {
            resolve(res.data?.data?.fetchSocketIO);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getGarbageCollectionData(
    context: { commit: Commit },
    params: {
      request: any;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryGarbageCollectionData')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.data?.gcList) {
              resolve(res.data?.data?.data);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getInstanceMemory(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
      duration: Object;
      pagination: Object;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryInstanceMemory')
          .params({
            request: {
              ...params,
              metricType: 'MEMORY_CLASS',
            },
          })
          .then((res: AxiosResponse<any>) => {
            resolve(res.data?.data?.memoryInfoResponse);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getGCConfiguration(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      // TODO: remove dummy params after api integration
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryGCConfig')
          .params({
            request: {
              ...params,
              metricType: 'GC_CONFIG',
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.fetchGarbageConfiguration?.status) {
              resolve(res.data?.data?.fetchGarbageConfiguration);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getMethodProfile(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      // TODO: remove dummy params after api integration
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryMethodProfile')
          .params({
            request: {
              metricType: 'GC_CONFIG',
              ...params,
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.fetchMethodProfilingInfo?.status) {
              resolve(res.data?.data?.fetchMethodProfilingInfo);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getStackTraceByThread(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
      threadId: String;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryStackTraceByThread')
          .params({
            request: {
              ...params,
            },
          })
          .then((res: AxiosResponse<any>) => {
            resolve(res.data?.data?.findStacktraceByThreadId);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getThreadByInstanceId(
    context: { commit: Commit },
    params: {
      serviceId: String;
      instanceId: String;
      threadId: String;
      pagination: Object;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryThreadByInstanceId')
          .params({
            request: {
              ...params,
            },
          })
          .then((res: AxiosResponse<any>) => {
            resolve(res.data?.data?.fetchThreadInfoByInstanceId);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getGarbageCollectionGraphData(
    context: { commit: Commit },
    params: {
      request: any;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryHeapAndMetaSummaryData')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.data) {
              resolve(res.data?.data?.data);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getTLABAllocationTableData(
    context: { commit: Commit },
    params: {
      request: any;
    },
  ) {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryTLABAllocationData')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.tlabTableResponse) {
              resolve(res.data?.data?.tlabTableResponse);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getMetaInfoByGCId(
    context: { commit: Commit },
    params: {
      request: any;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl;
        grahqlQueryServiceV2
          .query('queryMetaInfoByGcId')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.data?.gcList) {
              resolve(res.data?.data?.data?.gcList);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getTlabSummary(
    context: { commit: Commit },
    params: {
      request: any;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        grahqlQueryServiceV2
          .query('queryTlabSummary')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.respone) {
              resolve(res.data?.data?.respone);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getTlabGraphData(
    context: { commit: Commit },
    params: {
      request: any;
    },
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {
        grahqlQueryServiceV2
          .query('queryTlabGraphData')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (res.data?.data?.tlabGraph) {
              resolve(res.data?.data?.tlabGraph);
            } else {
              throw Error(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
};

export default actions;
